import { IUserSettings, SelectedLanguage } from 'api/api';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { upsertUserSettings } from 'state/ducks/user-settings/operations';
import { AppState } from 'state/store';
import { getSelectedLanguage } from 'utilities/language-util';
import { changeLanguage } from '../../../../state/i18n';
import LanguagePicker from './language-picker';
import './language-picker.scss';

const mapStateToProps = (state: AppState) => {
	return {
		userSettings: state.userSettingReducer.userSettings,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	updateUserSettings: async (userSetting: IUserSettings) => (await upsertUserSettings(userSetting))(dispatch),
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class SetUserLanguagePicker extends React.PureComponent<Props> {
	public render() {
		return (
			<LanguagePicker
				onSelectedChange={this.handleOnSiteLanguageChange}
				parentLanguage={this.props.userSettings.selectedLanguage}
			/>
		);
	}

	private handleOnSiteLanguageChange = async (selectedLanguage: SelectedLanguage) => {
		await changeLanguage(getSelectedLanguage(selectedLanguage));
		await this.props.updateUserSettings({
			...this.props.userSettings,
			selectedLanguage: selectedLanguage,
		});
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SetUserLanguagePicker);
